// Begin a Stripe checkout: ask the server for a hosted-Checkout URL and leave
// the SPA for it. One place, because leaving is the subtle part: when the funnel
// is embedded in the Elementor iframe, Stripe Checkout refuses to render framed,
// so we must break out to the top window; when hosted standalone, a plain
// same-window navigation is right.
import { startCheckout } from './api';
import { track } from './analytics';
import { postEvent } from './postMessage';

export async function beginCheckout(): Promise<void> {
  const { url } = await startCheckout();
  track('checkout_start');
  postEvent('checkout_start');
  try {
    if (window.top && window.top !== window) {
      // Cross-origin top navigation is permitted with user activation (this is
      // always called from a click). Sandboxed frames may throw — see catch.
      window.top.location.href = url;
      return;
    }
  } catch {
    // Fall through: a sandboxed embed that blocks top-navigation. A new tab is
    // the least-bad remaining path; Stripe's return URLs land back on the
    // canonical host either way.
    window.open(url, '_blank', 'noopener');
    return;
  }
  window.location.href = url;
}
